import { Dispatch, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import { RootState } from '../../lib/store';
import { getIndividualExtendedInfo } from '../../lib/store/common-actions';

import { Grid, LatestNews, Preloader, WatchList } from '../../components';
import { useIsMobile } from '../../hooks';

import styles from './Overview.module.scss';


type Props = ReduxProps;

const Overview = (props: Props) => {
  const { individualData, getIndividual } = props;
  const { isMobile } = useIsMobile();

  useEffect(() => {
    if (!individualData) {
      getIndividual();
    }
  }, [getIndividual, individualData]);

  const gridMainContent = (
    <div>
      <WatchList />
    </div>
  );

  const gridExtraContent = !isMobile ? (
    <div>
      <LatestNews />
    </div>
  ) : null;

  return (
    <>
      {!individualData ? (
        <div className={styles.loader}>
          <Preloader owner="Overview" />
        </div>
      ) : (
        <Grid extraChildren={gridExtraContent}>{gridMainContent}</Grid>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  individualData: state.crm.individualExtendedInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getIndividual: () => dispatch(getIndividualExtendedInfo()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Overview);
